import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Upload, Download, FileText, CheckCircle2, AlertCircle } from 'lucide-react';
type TabType = 'import' | 'export' | 'jobs';
export function AdminImportExportPage() {
  const [activeTab, setActiveTab] = useState<TabType>('import');
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-1068">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-1069">
        <div className="flex items-center gap-4" data-id="element-1070">
          <span className="text-xl font-bold text-red-500" data-id="element-1071">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-1072"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-1073">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-1074">
              Dashboard
            </Link>
            <Link to="/admin/import-export" className="text-textMain" data-id="element-1075">
              Data Operations
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-1076">
        <div className="mb-8" data-id="element-1077">
          <h1 className="text-2xl font-bold mb-1" data-id="element-1078">Import & Export</h1>
          <p className="text-sm text-textMuted" data-id="element-1079">
            Manage bulk data operations for venues, contacts, and bookings.
          </p>
        </div>

        <div className="flex gap-6 border-b border-border mb-6" data-id="element-1080">
          {(['import', 'export', 'jobs'] as TabType[]).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium transition-colors capitalize ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-1081">
              {tab === 'jobs' ? 'Job History' : tab}
            </button>)}
        </div>

        {activeTab === 'import' && <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1082">
            <div className="bg-surface border border-border rounded-xl p-6 text-center hover:border-primary/50 transition-colors cursor-pointer group" data-id="element-1083">
              <div className="w-16 h-16 rounded-full bg-blue-500/10 text-blue-500 flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-500/20 transition-colors" data-id="element-1084">
                <Upload className="w-8 h-8" data-id="element-1085" />
              </div>
              <h3 className="font-bold text-lg mb-2" data-id="element-1086">Import Contacts</h3>
              <p className="text-sm text-textMuted mb-4" data-id="element-1087">
                Upload a CSV of venue contacts, promoters, or agents.
              </p>
              <button className="text-sm font-medium text-primary hover:underline" data-id="element-1088">
                Download Template
              </button>
            </div>

            <div className="bg-surface border border-border rounded-xl p-6 text-center hover:border-primary/50 transition-colors cursor-pointer group" data-id="element-1089">
              <div className="w-16 h-16 rounded-full bg-green-500/10 text-green-500 flex items-center justify-center mx-auto mb-4 group-hover:bg-green-500/20 transition-colors" data-id="element-1090">
                <Upload className="w-8 h-8" data-id="element-1091" />
              </div>
              <h3 className="font-bold text-lg mb-2" data-id="element-1092">Import Venues</h3>
              <p className="text-sm text-textMuted mb-4" data-id="element-1093">
                Upload a CSV of venue details, capacities, and locations.
              </p>
              <button className="text-sm font-medium text-primary hover:underline" data-id="element-1094">
                Download Template
              </button>
            </div>

            <div className="bg-surface border border-border rounded-xl p-6 text-center hover:border-primary/50 transition-colors cursor-pointer group" data-id="element-1095">
              <div className="w-16 h-16 rounded-full bg-purple-500/10 text-purple-500 flex items-center justify-center mx-auto mb-4 group-hover:bg-purple-500/20 transition-colors" data-id="element-1096">
                <Upload className="w-8 h-8" data-id="element-1097" />
              </div>
              <h3 className="font-bold text-lg mb-2" data-id="element-1098">Import Bookings</h3>
              <p className="text-sm text-textMuted mb-4" data-id="element-1099">
                Migrate historical show data from spreadsheets.
              </p>
              <button className="text-sm font-medium text-primary hover:underline" data-id="element-1100">
                Download Template
              </button>
            </div>
          </div>}

        {activeTab === 'jobs' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-1101">
            <table className="w-full text-sm text-left" data-id="element-1102">
              <thead className="text-xs text-textMuted uppercase bg-background/50 border-b border-border" data-id="element-1103">
                <tr data-id="element-1104">
                  <th className="px-6 py-4 font-medium" data-id="element-1105">Job ID</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1106">Type</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1107">Status</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1108">Records</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1109">Started</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1110">Completed</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-1111">
                {[{
              id: 'JOB-992',
              type: 'Venues Import',
              status: 'Completed',
              records: '1,240 / 1,240',
              start: 'Today, 10:00 AM',
              end: 'Today, 10:05 AM',
              icon: <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-1112" />
            }, {
              id: 'JOB-991',
              type: 'Contacts Import',
              status: 'Completed w/ Errors',
              records: '850 / 900',
              start: 'Yesterday, 2:00 PM',
              end: 'Yesterday, 2:02 PM',
              icon: <AlertCircle className="w-4 h-4 text-amber-500" data-id="element-1113" />
            }, {
              id: 'JOB-990',
              type: 'Full Export',
              status: 'Completed',
              records: '15,420',
              start: 'Jun 1, 1:00 AM',
              end: 'Jun 1, 1:15 AM',
              icon: <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-1114" />
            }].map((job, i) => <tr key={i} className="hover:bg-surfaceHover/50 transition-colors" data-id="element-1115">
                    <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-1116">
                      <FileText className="w-4 h-4 text-textMuted" data-id="element-1117" /> {job.id}
                    </td>
                    <td className="px-6 py-4" data-id="element-1118">{job.type}</td>
                    <td className="px-6 py-4 flex items-center gap-2" data-id="element-1119">
                      {job.icon} {job.status}
                    </td>
                    <td className="px-6 py-4" data-id="element-1120">{job.records}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-1121">{job.start}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-1122">{job.end}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </motion.div>
    </div>;
}